module.exports = __webpack_public_path__ + "media/images/man-profile-3-d2a69660f9038ccf3767fc0d36df27f3.jpeg";